/** 種々の上限値、加減値 */
export const COMMON_LIMIT_NUM = {
    /** お気に入りフォルダ数上限 */
    FAVORITES_FOLDER_LIMIT: 10,
    /** フォルダ名上限 */
    FAVORITES_FOLDER_NAME_LIMIT: 15,
    /** パントリー一覧取得件数上限 */
    PANTRY_LIST_ITEM_LIMIT: 30,
    /** 食材追加一覧取得件数上限 */
    INSTRUCTION_LIST_ITEM_LIMIT: 50,
    /** パントリー一覧取得件数（初回） */
    PANTRY_LIST_ITEM_FIRST_LIMIT: 30,
    /** パントリー一覧取得件数（ページング） */
    PANTRY_LIST_ITEM_PAGING_LIMIT: 10,
    /** パントリー一覧取得件数（初回） */
    PANTRY_LIST_RECIPE_SEARCH_FIRST_LIMIT: 15,
    /** パントリー一覧取得件数（ページング） */
    PANTRY_LIST_RECIPE_SEARCH_ITEM_PAGING_LIMIT: 9
};